import { PlayerError } from "./player.error";

export class UnauthorizedStreamPlayerError extends PlayerError {
  constructor(e: unknown) {
    super(e);
    this.name = "UnauthorizedStreamPlayerError";
  }
}
